import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueSelectorPlaceholder: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.issue.issue-selector.issue-selector-placeholder',
		defaultMessage: 'Choose an issue...',
		description: 'Placeholder to show when no search text entered in issue selector',
	},
	issueFilterWithRollupNotSupported: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.issue.issue-selector.issue-filter-with-rollup-not-supported',
		defaultMessage: 'Issue filter is not supported with roll-up',
		description: 'Placeholder to show that the issue filter is not supported with roll-up',
	},
	issueFilterLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.issue.issue-selector.issue-filter-label',
		defaultMessage: 'Issue',
		description: 'Label for issue filter',
	},
});
